import { ancanaApi } from "./ancanaApi";

/**
 * Minimal id/name lists for pickers.
 *
 * Both sets are small — 27 destinations and around 110 listings — so they load
 * once in full and the Select searches them in the browser. That is simpler and
 * faster to use than a debounced server search, and it stays true until the
 * portfolio is an order of magnitude bigger.
 */

export interface ILookupOption {
  id: number;
  name: string;
}

const page = (path: string) =>
  ancanaApi
    .get<{ results?: ILookupOption[] } | ILookupOption[]>(path, {
      params: { fields: "id,name", page_size: 500 },
    })
    .then((r) => (Array.isArray(r.data) ? r.data : r.data.results ?? []));

export const lookupsApi = {
  destinations: () => page("destinations/"),
  listings: () => page("listings/"),
};
